import { render, staticRenderFns } from "./lawJudgement.vue?vue&type=template&id=5709ce0c&scoped=true&"
import script from "./lawJudgement.vue?vue&type=script&lang=js&"
export * from "./lawJudgement.vue?vue&type=script&lang=js&"
import style0 from "./lawJudgement.vue?vue&type=style&index=0&lang=css&"
import style1 from "./lawJudgement.vue?vue&type=style&index=1&id=5709ce0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5709ce0c",
  null
  
)

export default component.exports